<template>
  <div class="ceo">
    <!-- <sub-header /> -->

    <article class="sub-body res_wrap px-3">
      <section class="sub-body-title">
        <h3 class="text-h4 text-sm-h2 font-weight-bold">CEO Message</h3>
        <p>안녕하십니까? ㈜제인소프트 대표이사 김광기입니다.</p>
      </section>
      <section class="sub-body-content">
        
        <v-container fluid>
          <v-row class="align-stretch">
            
            <v-col cols="12" sm="3">
              <v-card class="rounded-xl"><v-img :src="require('@/assets/img_sub_ceo_01.jpg')"></v-img></v-card>
            </v-col>
            <v-col cols="12" sm="9">
              <div >
                여러 고객사의 관심과 성원에 항상 감사드리며, 2011년 회사 설립 이후 저희 제인소프트는 고객사 업무시스템의 UI/UX 기반 시스템 개편/재구축 업무를 중심으로 비즈니스를 확대해왔습니다.<br><br>
                이러한 비즈니스를 통해 고객사의 업무 수행의 효율화와 사용자 관점의 편의성을 시스템 구축의 최대 목표로 삼고 고품질의 IT Service를 제공하고 있습니다.<br><br>
                많은 난관과 복잡한 비즈니스 환경에서도 도전정신과 창의성을 잃지 않는 기업으로 성장해 갈 것을 약속드리며 고객/임직원의 만족을 최우선으로 기업 경영에 매진할 것이니 지켜봐 주시고 많은 격려와 조언을 부탁 드립니다.<br><br>
                감사합니다.<br>
                ㈜제인소프트 대표이사   김광기
              </div>
            </v-col>

          </v-row>
        </v-container>

      </section>
    </article>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'ceo',
  data() {
    return {
    };
  },

  created () {
  },

  mounted: function(){
    gsap.from(".ceo .sub-body-title", {
      scrollTrigger: {
        trigger: ".ceo .sub-body-title",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3,
    });
    gsap.from(".ceo .sub-body-content", {
      scrollTrigger: {
        trigger: ".ceo .sub-body-content",
        toggleActions: "restart none none none",
      },
      duration: .6, y: 50, opacity: 0, stagger: .3, delay: .3
    });
  },

  methods: {

  }

};
</script>

<style scoped>
</style>